<template>
  <div class="flex-1 overflow-auto p-4">
    <woot-button
      v-if="hasCreatePermission('CSAT Survey')"
      color-scheme="success"
      :class-names="`button--fixed-top`"
      icon="add-circle"
      @click="openAddPopup"
    >
      {{ $t('CSAT_MGMT.HEADER_BTN_TXT') }}
    </woot-button>
    <div class="flex flex-row gap-4">
      <div class="w-[66%]">
        <p
          v-if="!uiFlags.isFetching && !surveys.length"
          class="flex h-full items-center flex-col justify-center"
        >
          {{ $t('CSAT_MGMT.LIST.404') }}
        </p>
        <woot-loading-state
          v-if="uiFlags.isFetching"
          :message="$t('CSAT_MGMT.LOADING')"
        />
        <table v-if="!uiFlags.isFetching && surveys.length" class="woot-table">
          <thead>
            <th
              v-for="thHeader in $t('CSAT_MGMT.LIST.TABLE_HEADER')"
              :key="thHeader"
            >
              {{ thHeader }}
            </th>
          </thead>
          <tbody>
            <tr v-for="(survey, index) in surveys" :key="survey.title">
              <td>{{ survey.title }}</td>
              <td>
                <span
                  class="inline-block max-w-[80%] overflow-hidden whitespace-nowrap text-ellipsis"
                >
                  {{ survey.description }}
                </span>
              </td>
              <td>
                <div class="flex gap-1">
                  <woot-button
                    v-if="hasEditPermission('CSAT Survey')"
                    v-tooltip.top="$t('CSAT_MGMT.FORM.EDIT')"
                    variant="smooth"
                    size="tiny"
                    color-scheme="secondary"
                    class-names="grey-btn"
                    :is-loading="loading[survey.id]"
                    icon="edit"
                    @click="openEditPopup(survey)"
                  />
                  <woot-button
                    v-if="
                      hasDeletePermission('CSAT Survey') && !survey.is_default
                    "
                    v-tooltip.top="$t('CSAT_MGMT.FORM.DELETE')"
                    variant="smooth"
                    color-scheme="alert"
                    size="tiny"
                    icon="dismiss-circle"
                    class-names="grey-btn"
                    :is-loading="loading[survey.id]"
                    @click="openDeletePopup(survey, index)"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="w-[34%]">
        <span v-dompurify-html="$t('CSAT_MGMT.SIDEBAR_TXT')" />
      </div>
    </div>
    <woot-modal
      :show.sync="showAddPopup"
      :on-close="hideAddPopup"
      size="medium"
    >
      <survey-form :item="selectedSurvey" @close="hideAddPopup" />
    </woot-modal>

    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('CSAT_MGMT.DELETE.CONFIRM.TITLE')"
      :message="$t('CSAT_MGMT.DELETE.CONFIRM.MESSAGE')"
      :message-value="deleteMessage"
      :confirm-text="deleteConfirmText"
      :reject-text="deleteRejectText"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SurveyForm from './components/SurveyForm.vue';
import alertMixin from 'shared/mixins/alertMixin';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';

export default {
  components: {
    SurveyForm,
  },
  mixins: [alertMixin, hasPermissionMixin],
  data() {
    return {
      loading: {},
      showAddPopup: false,
      showEditPopup: false,
      showDeleteConfirmationPopup: false,
      selectedSurvey: {},
    };
  },
  computed: {
    ...mapGetters({
      records: 'csatSurveys/getCsatSurveys',
      uiFlags: 'csatSurveys/getUIFlags',
    }),
    surveys() {
      return this.records.filter(survey => !survey.is_default);
    },
    // Delete Modal
    deleteConfirmText() {
      return this.$t('CSAT_MGMT.DELETE.CONFIRM.YES');
    },
    deleteRejectText() {
      return this.$t('CSAT_MGMT.DELETE.CONFIRM.NO');
    },
    deleteMessage() {
      return ` ${this.selectedSurvey.title}?`;
    },
  },
  mounted() {
    this.$store.dispatch('csatSurveys/get');
  },
  methods: {
    openAddPopup() {
      this.selectedSurvey = {};
      this.showAddPopup = true;
    },
    openEditPopup(survey) {
      this.selectedSurvey = survey;
      this.showAddPopup = true;
    },
    hideAddPopup() {
      this.selectedSurvey = {};
      this.showAddPopup = false;
    },

    openDeletePopup(survey) {
      this.showDeleteConfirmationPopup = true;
      this.selectedSurvey = survey;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },

    confirmDeletion() {
      this.loading[this.selectedSurvey.id] = true;
      this.closeDeletePopup();
      this.deleteCsat(this.selectedSurvey.id);
    },
    deleteCsat(id) {
      this.$store
        .dispatch('csatSurveys/delete', id)
        .then(() => {
          this.showAlert(this.$t('CSAT_MGMT.DELETE.API.SUCCESS_MESSAGE'));
        })
        .catch(() => {
          this.showAlert(this.$t('CSAT_MGMT.DELETE.API.ERROR_MESSAGE'));
        })
        .finally(() => {
          this.loading[this.selectedSurvey.id] = false;
        });
    },
  },
};
</script>
<style scoped lang="scss"></style>
